import { SxProps, Theme } from "@mui/system";
import Colors from "../../theme/Colours";

export const downloadIconStyle: SxProps<Theme> = {
  width: "28px",
  height: "28px",
  cursor: "pointer",
};

export const downloadStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "20px",
  mb: 2,
};

export const invoiceLayoutBox: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  gap: "30px",
};

export const invoiceBox: SxProps<Theme> = {
  width: "100%",
};

export const titleTypography: SxProps<Theme> = {
  fontWeight: "500",
  marginBottom: "44px",
  fontSize: "20px",
};

export const borderBox: SxProps<Theme> = {
  border: "3px solid black",
};

export const updateButtonBox: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  paddingTop: "85px",
  paddingBottom: "140px",
};

export const updateButton: SxProps<Theme> = {
  width: "180px",
  height: "36px",
  padding: "6px 16px",
  borderRadius: "5px",
  fontWeight: "600",
  fontSize: "14px",
  backgroundColor: Colors.background2,
  border: `1px solid ${Colors.primaryButtonOrange}`,
  color: Colors.primaryButtonOrange,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: Colors.primaryButtonOrange,
    color: Colors.background2,
    boxShadow: "none",
  },
};
export const downloadButton: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "20px",
  marginBottom: 16,
};

export const editButton: SxProps<Theme> = {
  width: "100px",
  minWidth: "100px",
  height: "30px",
  padding: "2px 10px",
  borderRadius: "5px",
  fontWeight: "600",
  fontSize: "13px",
  fontFamily: "poppins",
  backgroundColor: Colors.background2,
  border: `1px solid ${Colors.primaryButtonOrange}`,
  color: Colors.primaryButtonOrange,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: Colors.primaryButtonOrange,
    color: Colors.background2,
    boxShadow: "none",
    border: `1px solid ${Colors.primaryButtonOrange}`,
  },
};
